import React, { useEffect, useState } from 'react'
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Button, TextField, CircularProgress } from '@material-ui/core';
import DataTable from '../Table';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { useLocation, useNavigate } from 'react-router-dom';
import RefreshIcon from '@material-ui/icons/Refresh';
import { getAssetPLILogs } from '../../ReduxStore/AssetDisposalSlice';
import * as XLSX from 'xlsx';
import GetAppIcon from '@material-ui/icons/GetApp';
import { convertUTCtoIST } from '../../helpers/DateConvert';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import SearchIcon from '@material-ui/icons/Search';
import { formatDateTime } from '../../helpers/DateConvert';

const columns = [
    { id: 'Sr.no', label: 'Sr.no', minWidth: 50 },
    { id: 'Action', label: 'Action', minWidth: 80 },
    { id: 'asset_no', label: 'Asset', minWidth: 80 },
    { id: 'form_data.asset_description', label: 'Description', minWidth: 150 },
    { id: 'form_data.asset_name', label: 'Asset Name', minWidth: 80 },
    { id: 'form_data.status', label: 'Status', minWidth: 100 },
    // { id: 'form_data.vendor_no', label: 'Vendor', minWidth: 120 },
    { id: 'vendor_no', label: 'Vendor Code', minWidth: 120 },
    { id: 'form_data.serial_no', label: 'Serial No', minWidth: 100 },
    { id: 'form_data.installation_location', label: 'Installation Location', minWidth: 150 },
    { id: 'form_data.invoice_no', label: 'Invoice No', minWidth: 100 },
    { id: 'form_data.make', label: 'Manufacturer', minWidth: 100 },
    { id: 'form_data.amount_capitalized', label: 'Amount Capitalized', minWidth: 100 },
    { id: 'form_data.model', label: 'Model', minWidth: 100 },
    { id: 'form_data.invoice_date', label: 'Invoice Date', minWidth: 100 },
    { id: 'submitby_name', label: 'Submitted by', minWidth: 100 },
    // { id: 'submitby_dept', label: 'Depratment', minWidth: 100 },
    { id: 'submit_date', label: 'Submitted Date', minWidth: 150 },
];




const PLITable = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const location = useLocation();
    const pathname = location.pathname.split('/');
    const asset_no = pathname[2];

    const [loading, setLoading] = useState(true);
    const [assetPLIs, setAssetPLIs] = useState([]);
    const [formData, setFormData] = useState({
        startDate: '',
        endDate: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const searchHandler = async () => {
        if (!formData.startDate) {
            toast.warn("Please select the Start Date first!")
            return
        }
        getAssetPLIs(`?from_time=${formatDateTime(formData.startDate)}&to_time=${formatDateTime(formData.endDate)}&sort=true`)
    }

    const resetHandler = async () => {
        setFormData({ startDate: '', endDate: '' });
        await getAssetPLIs(); // Refresh logs without filters
    };

    // const getAssetPLIs = async () => {
    //     try {
    //         const action = dispatch(getAssetPLILogs());
    //         const res = await action.unwrap();
    //         console.log("res", res.result)
    //         if (res.result) {
    //             const mergedLogs = res.result.map(log => ({
    //                 ...log,
    //                 submit_date: convertUTCtoIST(log.submit_date)
    //             }));
    //             const sortedLogs = mergedLogs.sort((a, b) => new Date(b.submit_date) - new Date(a.submit_date));
    //             setAssetPLIs(sortedLogs)
    //         };
    //     } catch (error) {
    //         console.error("Error in okHandler:", error);
    //         toast.error(error.message || "No Logs Found!");
    //     }
    // }

    const getAssetPLIs = async (param) => {
        try {
            const action = dispatch(getAssetPLILogs(param));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                const mergedLogs = res.result.map(log => ({
                    ...log,
                    asset_no: log.asset_no.slice(3),
                    submit_date: convertUTCtoIST(log.submit_date)
                }));
                // const sortedLogs = mergedLogs.sort((a, b) => new Date(b.submit_date) - new Date(a.submit_date));
                setAssetPLIs(mergedLogs)
            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }


    const exportToExcel = () => {
        const formattedData = assetPLIs.map((item, index) => ({
            'Sr.no': index + 1,  // Auto-incrementing row number
            'Asset': item.asset_no,
            'Description': item.form_data.asset_description,
            'Asset Name': item.form_data.asset_name,
            'Status': item.form_data.status,
            'Vendor': item.form_data.vendor_no,
            'Serial No': item.form_data.serial_no,
            'Installation Location': item.form_data.installation_location,
            'Invoice No': item.form_data.invoice_no,
            'Manufacturer': item.form_data.make,
            'Amount Capitalized': item.form_data.amount_capitalized,
            'Model': item.form_data.model,
            'Invoice Date': item.form_data.invoice_date,
            'Submitted by': item.submitby_name,
            'Department': item.submitby_dept,
            'Submitted Date': item.submit_date,
        }));

        // Create a new worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate a buffer and trigger the download
        XLSX.writeFile(workbook, 'Asset_PLIS.xlsx');
    };

    useEffect(() => {
        const fetchData = async () => {
            await getAssetPLIs();
            setLoading(false);
        };
        fetchData();
    }, [])


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} mt={1}>
                    {/* <Typography variant="h5" component="h1" gutterBottom>
                        PLI History
                    </Typography> */}
                    {/* <Grid item>
                        <Button
                            type="button"
                            variant="contained"
                            color="primary"
                            onClick={() => navigate(`/pli-form/${asset_no}`)}
                            fullWidth
                            size='medium'
                        >
                            Create PLI Request
                        </Button>
                    </Grid> */}

                </Box>
                <Box mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="PLI History" />
                </Box>
                <Box mt={4} mb={2}>
                    <Grid container spacing={1}>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="From"
                                name="startDate"
                                type="date"
                                size="small"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.startDate}
                                onChange={handleInputChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <TextField
                                label="To"
                                name="endDate"
                                type="date"
                                size="small"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={formData.endDate}
                                onChange={handleInputChange}
                            />
                        </Grid>

                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="primary"
                                className="customButton"
                                fullWidth
                                onClick={searchHandler}
                                // endIcon={loading ? <CircularProgress size={20} /> : <SearchIcon />}
                                endIcon={<SearchIcon />}
                            >
                                Search
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="customButton"
                                fullWidth
                                onClick={resetHandler}
                                endIcon={<RefreshIcon />}
                            >
                                Reset
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
                {/* <Box mb={2}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export Excel
                            </Button>
                        </Grid>
                    </Grid>
                </Box> */}
                <Box mb={2}>
                    <Grid container>
                        <Grid item xs={12}>
                            {assetPLIs?.length > 0 ? (
                                <DataTable data={assetPLIs} columns={columns} pagination={false} />
                            ) : (
                                <>
                                    <Typography variant="h6" align="center">
                                        No PLI History
                                    </Typography>
                                    <Typography variant="h6" align="center">
                                        Click on Create PLI Request
                                    </Typography>
                                </>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Container>
            <ToastContainer />
        </Layout>
    )
}

export default PLITable